enum PathEnum {
    MAIN = "/",
    REJECTED_APPLICATION = "/rejectedApplication",
    ACCEPTED_APPLICATION = "/acceptedApplication",
    EXTERNAL_SITE_IN_LOKI = "/externalSiteInLoki",
    ACCESS_DENIED = "/accessDenied"
}

export default PathEnum;
